<template>
  <div>
    <div v-if="learningUnit" class="h5 display-4 mt-1 mb-4 font-weight-bold">
      {{ learningUnit.name }}
    </div>

    <BaseFormSection
      v-if="learningUnit && sectionId"
      :learning-unit="learningUnit"
      :conflict="conflict"
    >
    </BaseFormSection>
  </div>
</template>

<script>
import BaseFormSection from './BaseFormSection';
import { sectionMixin } from '@/mixins';

export default {
  components: {
    BaseFormSection
  },

  mixins: [sectionMixin],
  props: {
    conflict: {
      type: Boolean,
      default: false
    }
  },

  async mounted() {
    await this.fetchLearningUnit();

    await this.fetchSectionById();
  }
};
</script>
